import { MAuth } from '../../models/auth.model'
import { AuthActionTypes } from './auth.action-types'

const initialStates = {
    authToken: '',
    register: {},
    user: {},
    accessToken: '',
    publicToken: '',
    isLoading: false,
}

const AuthReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case AuthActionTypes.SET_GLOBAL_LOADING:
            return { ...state, isLoading: action.payload }
        case AuthActionTypes.GET_AUTHORIZE_TOKEN:
            return { ...state, authToken: action.payload }
        case AuthActionTypes.GET_PUBLIC_TOKEN:
            return { ...state, publicToken: action.payload }
        case AuthActionTypes.SET_REGISTER:
            return { ...state, register: action.payload }
        case AuthActionTypes.LOGIN:
            return {
                ...state,
                ...action.payload,
            }
        case AuthActionTypes.LOGOUT:
            return { ...state, ...initialStates }

        case AuthActionTypes.UPDATE_PROFILE:
            return {
                ...state,
                user: { ...state.user, profile: action.payload },
            }
        default:
            return state
    }
}

export default AuthReducer
